import { render } from "./TText.vue?vue&type=template&id=6adaa3bc"
import script from "./TText.vue?vue&type=script&lang=js"
export * from "./TText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__